<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'信贷明细'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="释放日期" style="width: 50%;">
								<el-date-picker
									v-model="formInline.releaseDateStart"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="formInline.releaseDateEnd"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="　　信贷有效期" style="width: 50%;">
								<el-date-picker
									v-model="formInline.validitydateStart"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="formInline.validitydateEnd"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="申请日期" style="width: 50%;">
										<el-date-picker
											v-model="formInline.cdateStart"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
											v-model="formInline.cdateEnd"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="　经销商名称/编码">
									    <el-input v-model="formInline.codeNameSearch" placeholder="模糊查询"></el-input>
									</el-form-item>
									<el-form-item label="信贷类型">
									    <brselectlazy category="cre_category" :v="formInline.creCategory"
									                  v-model="formInline.creCategory" :clearable="true"/>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="顺序编码">
									    <el-input v-model="formInline.cid" placeholder=""></el-input>
									</el-form-item>
									<el-form-item label="公司代码">
									    <el-input v-model="formInline.kkber" placeholder=""></el-input>
									</el-form-item>
									<el-form-item label="信贷状态">
									    <brselectlazy category="credit_status" :v="formInline.status"
									                  v-model="formInline.status" :clearable="true"/>
									</el-form-item>
									<el-form-item label="国内区域">
									    <brselectlazy category="YLRegion" :v="formInline.area"
									                  v-model="formInline.area" :clearable="true"/>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="国外区域">
									    <brselectlazy category="YLCountry_agent" :v="formInline.area1"
									                  v-model="formInline.area1" :clearable="true"/>
									</el-form-item>
								</div>

							</div>
						</el-collapse-transition>

                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="queryCreditList">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
							</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChange"
                                :data="tableData2"
                                stripe
                                border
                                style="width: 100%"
								max-height="450"

                        >
                            <el-table-column
                                    type="selection"
                                    width="40"
                                    label="全选"
                                    fixed
                            >
                            </el-table-column>
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    label="信贷id"
									:show-overflow-tooltip="true"
                                    width="170">
                            </el-table-column>
                            <el-table-column
                                    prop="cid"
                                    label="顺序编码"
									:show-overflow-tooltip="true"
                                    width="90">
                            </el-table-column>
                            <el-table-column
                                    prop="username"
                                    label="经销商名称"
                                    :show-overflow-tooltip="true"
                                    min-width="180">
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">
                                            {{scope.row.username}}
                                        </div>
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    prop="usercode"
                                    label="经销商编码"
                                    :show-overflow-tooltip="true"
                                    min-width="110">
                            </el-table-column>
							<el-table-column
                  v-if="!shengjiFlag"
									prop="useQuota"
									label="使用金额"
									:show-overflow-tooltip="true"
									min-width="100">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.useQuota}}
									</div>
								</template>
							</el-table-column>
                            <el-table-column
                                    v-if="!shengjiFlag"
                                    prop="quota"
                                    label="信贷余额"
                                    :show-overflow-tooltip="true"
                                    min-width="100">
										<template slot-scope="scope">
										    <div style="text-align: right;">
										        {{scope.row.quota}}
										    </div>
										</template>
                            </el-table-column>
                          <el-table-column
                              v-if="!shengjiFlag"
                              prop="hkquota"
                              label="回款金额"
                              :show-overflow-tooltip="true"
                              min-width="100">
                            <template slot-scope="scope">
                              <div style="text-align: right;">
                                {{scope.row.hkquota}}
                              </div>
                            </template>
                          </el-table-column>
							<el-table-column
                  v-if="!shengjiFlag"
									prop="yqQuota"
									label="逾期金额"
									:show-overflow-tooltip="true"
									min-width="100">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.yqQuota}}
									</div>
								</template>
							</el-table-column>
                            <el-table-column
                                    prop="maxquota"
                                    :show-overflow-tooltip="true"
                                    label="信贷总额"
                                    min-width="90">
										<template slot-scope="scope">
										    <div style="text-align: right;">
										        {{scope.row.maxquota}}
										    </div>
										</template>
                            </el-table-column>
                            <el-table-column
                                    prop="kkber"
                                    label="公司代码"
                                    :show-overflow-tooltip="true"
                                    min-width="90">
                            </el-table-column>
                            <el-table-column
                                    prop="status"
                                    label="状态"
                                    :show-overflow-tooltip="true"
                                    width="70">
                                <template slot-scope="scope">
                                    {{scope.row.status | dictname('credit_status')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="creCategory"
                                    label="信贷类型"
                                    :show-overflow-tooltip="true"
                                    width="110">
                                <template slot-scope="scope">
                                    {{scope.row.creCategory | dictname('cre_category')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="productId"
                                    label="专属信贷产品大类"
                                    :show-overflow-tooltip="true"
                                    width="160">
                                <template slot-scope="scope">
                                    {{scope.row.productId | dictname('product_level')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="isOverdue"
                                    label="是否逾期"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template slot-scope="scope">
                                    {{scope.row.isOverdue | dictname('is_overdue')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="overdueDays"
                                    label="逾期天数"
                                    :show-overflow-tooltip="true"
                                    width="90">
										<template slot-scope="scope">
										    <div style="text-align: right;">
										        {{scope.row.overdueDays}}
										    </div>
										</template>
                            </el-table-column>
                            <el-table-column
                                    prop="validitydate"
                                    label="信贷有效期"
                                    :show-overflow-tooltip="true"
                                    width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="paymentdate"
                                    label="批复账期"
                                    :show-overflow-tooltip="true"
                                    width="100">
                            </el-table-column>
                            <el-table-column
                                    prop="releaseDate"
                                    label="信贷释放时间"
                                    :show-overflow-tooltip="true"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="cuname"
                                    label="申请人"
                                    :show-overflow-tooltip="true"
                                    width="80">
                            </el-table-column>
                            <el-table-column
                                    prop="cdate"
                                    label="申请时间"
                                    :show-overflow-tooltip="true"
                                    width="100">
                            </el-table-column>
                            <el-table-column
                                    prop="approverNames"
                                    label="审批人"
                                    :show-overflow-tooltip="true"
                                    width="160">
                            </el-table-column>
                            <el-table-column
                                    prop="projectName"
                                    label="项目名称"
                                    :show-overflow-tooltip="true"
                                    width="160">
                            </el-table-column>

                            <el-table-column
                                    prop="qdmanger"
                                    label="渠道经理"
                                    :show-overflow-tooltip="true"
                                    min-width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="qymanger"
                                    label="区域经理"
                                    :show-overflow-tooltip="true"
                                    min-width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="ptjkr"
                                    label="平台接口人"
                                    :show-overflow-tooltip="true"
                                    min-width="110">
                            </el-table-column>
                            <el-table-column
                                    prop="lianqunzhu"
                                    label="链群主"
                                    :show-overflow-tooltip="true"
                                    min-width="110">
                            </el-table-column>

                            <el-table-column
                              label="操作"
                              :show-overflow-tooltip="true"
							  fixed="right"
                              width="220">
                                  <template slot-scope="scope">
                                     <div style="text-align: left;">
										 <el-button
										      v-show="scope.row.instid != null && scope.row.instid != ''"
										      type="text"
										       size="small"
										       class="h-tableLink h-btn"
										       @click="viewpress(scope.row)"
										       >跟踪
										 </el-button>
										  <el-button
										          type="text"
										          size="small"
										          class="h-tableLink h-btn"
										          @click="seeDetail(scope.row)"
										  >查看
										  </el-button>
										 <el-button v-auth="'xindai_xdzq'" v-if="scope.row.validitydate!=null" class="h-tableLink h-btn"  @click="xiugaiDate(scope.row)">
											 信贷展期
										 </el-button>
									 </div>
                                    <!-- <div class="l-operationBox">
                                         <span class="l-operationlist br-operation-spgz" v-show="scope.row.status == '3'||scope.row.status == '1'" title="跟踪审批" @click="viewpress(scope.row)"></span>
                                     </div> -->
                                 </template>
                             </el-table-column>
                        </el-table>
                        <viewhistory
                                                :visible.sync="showhistory"
                                                v-if="showhistory"
                                                :id="instid"
                                        />
                    </div>

					<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2 wuliu">
						<div class="h-dialogImg">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>信贷展期</h1>
								</div>
							</div>
						</div>
						<div class="h-formLine">
							<el-form ref="form" :model="fpform" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
								<el-form-item  label="信贷有效期" class="h-elformWrap-2">
									<el-input  v-model="fpform.validitydate" placeholder="请填写信贷有效期" readonly></el-input>
								</el-form-item>
								<el-form-item label="调整至日期" class="h-elformWrap-2">
									<el-date-picker
											placeholder="请选择"
											v-model="fpform.validitydatenew"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="附件" class="h-elformWrap-1">
									<brupload :refid="fpform.id" reftype="信贷有效期" :showtime="false" uploadflag delflag></brupload>
								</el-form-item>
							</el-form>
						</div>
						<div slot="footer" class="dialog-footer">
							<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel2">取消</el-button>
							<el-button class="h-btn h-formBtn" type="primary" @click="saveTo2">确定</el-button>
						</div>
					</el-dialog>

                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ"
                                       v-if="!shengjiFlag"
                                       icon="h-el-icon h-el-icon-import" @click="exportExeal">批量导出
                            </el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="choose"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import util from "../../../utils/util";
    import updownfile from "../../../utils/updownfile";
    import ss from "../../../api/SystemService";

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
                dialogFormVisible2:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                value2: '',
                showhistory: false,
                value3: 36,
                names: '',
                input1: '',
                sele: '工程',
                formInline: {
                    releaseDateStart:null,
					releaseDateEnd:null,
                    status:null,
					area:null,
                    area1:null,
                    validitydateStart:null,
					validitydateEnd:null,
                    cdateStart:null,
					cdateEnd:null,
                  codeNameSearch: '',
                    cid: null,
                    kkber: null,
                    creCategory: null,
                    moneybackStatus: null,
                    pageSize: 10,
                    pageNo: 1,
                    ids:[],
                },
                multipleSelection: [],
                tableData2: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                fpform:{
                    validitydate:'',
                    id:'',
                    validitydatenew:'',
                },
                creditData: {
                    xdid: '',
                    pageSize: 10,
                    pageNo: 1,
                },
                isCheck: false,
                shengjiFlag: false,
            }
        },
        created() {
            //查询所有信贷列表
            this.queryCreditList();
            //审计
            this.shengjiFlag = this.$store.getters.hasRole('suoyouliebiaochakan');
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            exportExeal(){

                var ids = [];
                for (var d in this.multipleSelection) {
                    ids.push(this.multipleSelection[d].id);
                }
                this.formInline.ids = ids;

                updownfile.down("/api/swyl/v1/infoCredit/userInfoCredit/downloadExcel", this.formInline, 'post','data');

            },
            // 取消
            cancel2(){
                this.dialogFormVisible2 = false;
            },
			//确定
            saveTo2(){
                this.dialogFormVisible2 = false;
                    if(this.fpform.validitydatenew){
                        customerLedgerService.xiugaiDate(this.fpform).then(rd => {
                            if (rd.f) {
								this.$msg.msgs(rd.msg);
							}
                        });
                    }else{
                        this.$msg.msge('请输入调整后的信贷有效期')
                    }
			},
            // 查询信贷列表/检索按钮功能
            queryCreditList() {
                this.formInline.ids = [];
                customerLedgerService.queryCreditList(this.formInline).then(res => {
                    this.tableData2 = res.records;
                    this.q.total = res.total;
                })
            },
            timeSelect() {
                this.formInline.startCdate = this.value2[0];
                this.formInline.endCdate = this.value2[1];
            },
            //重置按钮功能
            resectData() {
                this.value2 = '';
                this.formInline.codeNameSearch = null;
                this.formInline.kkber = null;
                this.formInline.creCategory = null;
                this.formInline.creditStatus = null;
                this.formInline.releaseDateStart = "";
				this.formInline.releaseDateEnd = "";
                this.formInline.validitydateStart = "";
				this.formInline.validitydateEnd = "";
				this.formInline.cdateStart = "";
				this.formInline.cdateEnd = "";
                this.formInline.status = null;
                this.formInline.cid = null;
				this.formInline.area = null;
				this.formInline.area1 = null;
                this.formInline.pageNo = 1;
                this.formInline.pageSize = 10;

                this.q.pageNo = 1;
                this.q.pageSize = 10;
            },
            //分页按钮功能选择
            choose() {
                this.formInline.pageNo = this.q.pageNo;
                this.formInline.pageSize = this.q.pageSize;
                this.queryCreditList();
            },
            //查询该笔信贷对应订单列表
            queryOrderList() {
                this.creditData.pageNo = this.q.pageNo;
                this.creditData.pageSize = this.q.pageSize;
                customerLedgerService.queryOrderList(this.creditData).then(response => {
                    this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
            seeDetail(v) {
				var url = this.$router.resolve({path: '/customerOrder',query:{id:v.id}});
				window.open(url.href, "_blank");
            },
            xiugaiDate(v){
			    console.log(v,"cdfghjkl.;")
             //更新信贷有效期
                this.fpform.validitydate =v.validitydate;
                this.fpform.id =v.id;
                console.log(this.fpform.validitydate,"fghjkl;")
				this.dialogFormVisible2=true;
			},


            handleSelectionChange(val) {
                console.log(val,'val')
                this.multipleSelection = val;
            },
            viewpress(v) {
                            console.log("instid", v);
                            this.instid = v.instid;
                            this.showhistory = true;
                        },
            handleSizeChange() {
                console.log(1)
            },
            handleCurrentChange() {
                console.log(2)
            },
            handleScroll(e) {
                console.log(e.target.scrollLeft)
            }
        },
        mounted() {

        }
    }
</script>
<style scoped>

    /* .selectorBox{
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text{
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before{
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector{
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button{
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active{
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .tip{
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top:10px;
    }
    .h-bgccc{
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    } */
</style>
<style>
    /* .selectorBox .el-input-group__append{
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list{
        display: none;
    } */
    /* .h-rowIn .el-table .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    } */

    /* .drags .el-slider__button-wrapper .el-slider__button{
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    } */
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 6px;
    }
</style>
